import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';

import * as fromGraphql from './streets.graphql'
import * as fromActions from './streets.actions'


@Injectable()
export class StreetsEffects {
  getAllStreets$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllStreets),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_STREETS,
        fetchPolicy: 'network-only',
        variables: {
          wardUniqueId: action.wardUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadStreetss({ streetss: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {}
}
